module.exports = __webpack_public_path__ + "static/media/42.21f6257f.jpg";